import { KpiData, ValueLabelResponse } from '../../../../../../../types';

export const formatKpiData = (
  kpiData: KpiData,
  labels: Record<string, string>
): ValueLabelResponse[] => {
  return Object.entries(kpiData).map(([key, value]) => ({
    label: labels[key],
    value: value,
  }));
};
